import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Первым: синхронная инициализация i18next выставляет язык и <html lang> до первого рендера.
import '@/i18n'
import App from './App'
import { router } from './router'
import { setupPwaAutoUpdate } from '@/lib/pwa'
import '@/styles/globals.css'
// Side-effect: вешает module-level слушатель beforeinstallprompt на старте,
// до входа и монтирования AppLayout (событие фаерится рано).
import '@/hooks/useInstallPrompt'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

// Регистрация service worker и тихое применение обновлений — до рендера, чтобы
// подписка на маршруты успела встать раньше первой навигации.
setupPwaAutoUpdate(router)

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
